export default "__VITE_ASSET__CCjwtVDZ__"